import * as React from 'react'

import { Route, Routes } from 'react-router-dom'

import Error404 from '../ui/_pages/404'
import About from '../ui/_pages/About'
import Contact from '../ui/_pages/Contact'
import ContactSuccess from '../ui/_pages/ContactSuccess'
import Estate from '../ui/_pages/Estate'
import Fund from '../ui/_pages/Fund'
import { ImpressumScreen } from '../ui/_pages/Impressum'
import Investment from '../ui/_pages/Investment'
import Investments from '../ui/_pages/Investments'
import Jobs from '../ui/_pages/Jobs'
import Page from '../ui/_pages/Page'
import { PolicyScreen } from '../ui/_pages/Policy'
import Press from '../ui/_pages/Press'
import PressSinglePage from '../ui/_pages/PressSingle'
import Purchase from '../ui/_pages/Purchase'
import Rent from '../ui/_pages/Rent'
import Sale from '../ui/_pages/Sale'
import Sponsorship from '../ui/_pages/Sponsorship'
import Sponsorships from '../ui/_pages/Sponsorships'
import Tenant from '../ui/_pages/Tenant'
import { Main } from '../ui/templates/Main'
import routes from './routes'

export const Router = () => (
  <Routes>
    <Route path={routes.about} element={<About />} />
    <Route path={routes.contactSuccess} element={<ContactSuccess />} />
    <Route path={routes.contact} element={<Contact />} />
    <Route path={routes.estate} element={<Estate />} />
    <Route path={routes.fund} element={<Fund />} />
    <Route path={routes.impressum} element={<ImpressumScreen />} />
    <Route path={routes.indexDE} element={<Main />} />
    <Route path={routes.indexEN} element={<Main />} />
    <Route path={routes.indexPL} element={<Main />} />
    <Route path={routes.index} element={<Main />} />
    <Route path={routes.investments} element={<Investments />} />
    <Route path={routes.investment} element={<Investment />} />
    <Route path={routes.jobs} element={<Jobs />} />
    <Route path={routes.page} element={<Page />} />
    <Route path={routes.policy} element={<PolicyScreen />} />
    <Route path={routes.pressSingle} element={<PressSinglePage />} />
    <Route path={routes.press} element={<Press />} />
    <Route path={routes.purchase} element={<Purchase />} />
    <Route path={routes.rent} element={<Rent />} />
    <Route path={routes.sale} element={<Sale />} />
    <Route path={routes.sponsorship} element={<Sponsorship />} />
    <Route path={routes.sponsorships} element={<Sponsorships />} />
    <Route path={routes.tenant} element={<Tenant />} />
    <Route path={'*'} element={<Error404 />} />
  </Routes>
)
